<div class="navbar navbar-fixed-top navbar-dark bg-dark" style="height:30px;">
  <div class="navbar-inner">
    <div class="container">
    </div>
  </div>
</div>